import React from 'react'

export default function Login() {
  const onSubmit = (e) => { e.preventDefault(); alert('Implement auth flow') }
  return (
    <div style={{maxWidth:720, margin:'0 auto'}}>
      <section className="card">
        <h2 className="h2">Welcome back</h2>
        <p className="kv">Sign in to access your account and documents.</p>

        <form onSubmit={onSubmit} style={{display:'grid', gap:12, marginTop:12}}>
          <input className="input" type="email" placeholder="Email" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" type="password" placeholder="Password" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <label style={{fontSize:14}}><input type="checkbox" /> Remember me</label>
            {/* <a className="kv" href="h">Forgot password?</a> */}
            {/* TO DO: change this out */}
            <button onClick={() => {}}>Forgot password?</button>
          </div>
          <div style={{display:'flex', gap:12}}>
            <button className="btn primary" type="submit">Sign in</button>
            <a className="btn ghost" href="/signup">Create account</a>
          </div>
        </form>

        <div style={{marginTop:18}} className="kv">Or sign in with</div>
        <div style={{display:'flex', gap:8, marginTop:8}}>
          <button className="btn ghost" onClick={()=>alert('Google sign in')}>Google</button>
          <button className="btn ghost" onClick={()=>alert('Apple sign in')}>Apple</button>
        </div>
      </section>
    </div>
  )
}
